var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsInt, IsOptional, Max, Min } from 'class-validator';
export const STEUERBERATER_TOKEN_DEFAULT_EXPIRY_DAYS = 14;
export const STEUERBERATER_TOKEN_MAX_EXPIRY_DAYS = 90;
/**
 * Body for `POST /steuerberater-share-link/:officeLocationId`.
 *
 * Single-active-token model: minting revokes any existing ACTIVE row for the
 * same OfficeLocation, then issues a fresh token. `expiryDays` defaults to
 * 14 and is capped at 90 to keep the blast radius of a leaked link bounded.
 */
export class MintSteuerberaterTokenDto {
    expiryDays;
}
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    Max(STEUERBERATER_TOKEN_MAX_EXPIRY_DAYS),
    __metadata("design:type", Number)
], MintSteuerberaterTokenDto.prototype, "expiryDays", void 0);
//# sourceMappingURL=mint-steuerberater-token.dto.js.map